var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6805 3.65753C15.0175 3.65753 14.4812 4.19387 14.4812 4.85684C14.4812 5.51981 15.0175 6.05615 15.6805 6.05615C16.3435 6.05615 16.8798 5.51981 16.8798 4.85684C16.8798 4.19387 16.3435 3.65753 15.6805 3.65753Z",
    fill: "#D1A437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.332 5.19946C7.54603 5.19946 5.28149 7.464 5.28149 10.25C5.28149 13.0359 7.54603 15.3005 10.332 15.3005C13.118 15.3005 15.3825 13.0359 15.3825 10.25C15.3825 7.464 13.118 5.19946 10.332 5.19946ZM10.332 13.4829C8.55166 13.4829 7.09908 12.0303 7.09908 10.25C7.09908 8.46963 8.55166 7.01705 10.332 7.01705C12.1123 7.01705 13.5649 8.46963 13.5649 10.25C13.5649 12.0303 12.1123 13.4829 10.332 13.4829Z",
    fill: "#D1A437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3395 20.5H6.15286C2.75606 20.5 -0.00756836 17.7364 -0.00756836 14.3396V6.15298C-0.000119232 2.76363 2.76351 0 6.16031 0H14.3469C17.7437 0 20.5073 2.76363 20.5073 6.16043V14.347C20.5073 17.7438 17.7437 20.5074 14.3469 20.5074L14.3395 20.5ZM6.16031 1.92932C3.82873 1.92932 1.9292 3.82885 1.9292 6.16043V14.347C1.9292 16.6786 3.82873 18.5781 6.16031 18.5781H14.3469C16.6785 18.5781 18.578 16.6786 18.578 14.347V6.16043C18.578 3.82885 16.6785 1.92932 14.3469 1.92932H6.16031Z",
    fill: "#D1A437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 20.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIg);
export default __webpack_public_path__ + "static/media/icon-ig.18871476e80fe8a0f984566037d09da9.svg";
export { ForwardRef as ReactComponent };